import type { IconData } from '@stacksjs/iconify-core'

export const layoutWindow4Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.136 2.044C11.407 1.778 16.599 1.5 24 1.5s12.593.278 15.864.544c3.288.267 5.825 2.804 6.092 6.092c.115 1.419.233 3.199.33 5.364H1.714c.096-2.165.214-3.945.329-5.364c.267-3.288 2.804-5.825 6.092-6.092M1.605 16.5A255 255 0 0 0 1.5 24c0 7.401.278 12.593.544 15.864c.267 3.288 2.804 5.825 6.092 6.092c1.632.133 3.741.268 6.364.371V16.5zM17.5 46.423c1.942.048 4.105.077 6.5.077c7.401 0 12.593-.278 15.864-.544c3.288-.267 5.825-2.804 6.092-6.092c.266-3.271.544-8.463.544-15.864c0-2.814-.04-5.309-.105-7.5H17.5z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default layoutWindow4Solid
